import Store from '@/store/computed/storeHelpers'
import Api from '@/services/api'
export default {
  methods: {
    getVehicles() {
      this.loadingVehicles = true
      var urlString = 'vehicles'
      if (this.includeInactive) urlString += '/includeInactive'
      return Api.get(urlString)
        .then(result => {
          this.loadingVehicles = false
          this.vehicles = result.data.result
          return result.data.result
        })
        .catch(err => {
          console.log(err)
          this.loadingVehicles = false
          this.snackError()
        })
    }
  },
  computed: {
    loadingVehicles: Store.getSet({
      store: 'vehicles',
      prop: 'loadingVehicles'
    }),
    vehicles: Store.getSet({ store: 'vehicles', prop: 'vehicles' })
  },
  mounted() {
    if (!this.vehicles.length && this.$route.name !== 'audit') {
      this.getVehicles()
    }
  },
  beforeDestroy() {
    if (!this.keepMasterFiles) this.vehicles = []
  }
}
